export function validFileType(field) {
    const allowed = field.getAttribute("data-file-type").split(",");
    return allowed.includes(field.files[0].type);
}
